import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Splash from "@/components/Splash";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import RestaurantDetail from "@/pages/RestaurantDetail";
import Articles from "@/pages/Articles";
import ArticleDetail from "@/pages/ArticleDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import PostEventForm from "@/pages/PostEventForm";
import Watch from "@/pages/Watch";
import Services from "@/pages/Services";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ProfileForm from "@/pages/ProfileForm";
import ProfileDetail from "@/pages/ProfileDetail";
import ListingEdit from "@/pages/ListingEdit";
import Admin from "@/pages/Admin";
import AdminRoute from "@/components/AdminRoute";
import NotFound from "@/pages/NotFound";

function AppShell() {
  const location = useLocation();

  // Handle Google OAuth return BEFORE any route/auth logic (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <div className="App min-h-screen bg-sand-50 text-sand-900">
      <Navbar />
      <main className="pt-20">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/directory" element={<Directory />} />
          <Route path="/directory/:id" element={<RestaurantDetail />} />
          <Route path="/directory/:id/edit" element={<ProtectedRoute><ListingEdit /></ProtectedRoute>} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/articles/:id" element={<ArticleDetail />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/new" element={<ProtectedRoute><PostEventForm /></ProtectedRoute>} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/events/:id/edit" element={<ProtectedRoute><PostEventForm /></ProtectedRoute>} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/services" element={<Services />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile/:id" element={<ProfileDetail />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/profile/new" element={<ProtectedRoute><ProfileForm /></ProtectedRoute>} />
          <Route path="/profile/:id/edit" element={<ProtectedRoute><ProfileForm /></ProtectedRoute>} />
          <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(() => !sessionStorage.getItem("tb_splash_seen"));
  const finishSplash = () => {
    sessionStorage.setItem("tb_splash_seen", "1");
    setShowSplash(false);
  };
  return (
    <BrowserRouter>
      <AuthProvider>
        {showSplash && <Splash onDone={finishSplash} />}
        <AppShell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
